// extracted by mini-css-extract-plugin
module.exports = {"economicCalendarWrapper":"styles_economicCalendarWrapper__TyFfo","test":"styles_test__kbo55","calendarDisclaimer":"styles_calendarDisclaimer__qrq5D"};